import { makeStyles } from '@material-ui/core/styles';

export default makeStyles({
  profileCont: {
    display: 'flex',
  },
  avatar: {
    width: 30,
    height: 30,
    marginRight: 8,
  },
  userName: {
    fontSize: 15,
    fontWeight: 300,
    letterSpacing: 'normal',
    color: '#ffffff',
    padding: 5,
    fontFamily: 'Averta',
    textTransform: 'none',
  },
  bellIcon: {
    position: 'relative',
    padding: '6px 7px',
    minWidth: 'auto',
    borderRadius: '50px',
    border: '1px solid #F2AC4A !important',
    // margin: '0 15px',
    '& img': {
      height: 27,
      '@media (max-width:1160px)': {
        height: '22px',
      },
    },
    animation: ({ notif }) =>
      notif.chat || notif.order || notif.request ? 'heartBeat 1s' : '',
    '@media (max-width:1160px)': {
      margin: '10px',
    },
    '@media (max-width:800px)': {
      margin: '5px',
    },
  },
  notifIconCount: {
    position: 'absolute',
    background: 'red',
    borderRadius: '99px',
    minWidth: '19px',
    zIndex: 9,
    padding: '0px 4px',
    left: '26px',
    color: 'white',
    top: '-6px',
  },
  paper: {
    top: '75px !important',
    boxShadow: '2px 2px 10px 0 rgba(0, 0, 0, 0.2)',
    backgroundColor: '#fff',
    borderRadius: 10,
    overflow: 'visible',
    '&::before': {
      position: 'absolute',
      right: 16,
      top: -13,
      width: 25,
      height: 25,
      backgroundColor: '#fff',
      content: '""',
      transform: 'rotate(-45deg)',
      borderRadius: '0 5px',
      zIndex: 0,
    },
  },
  notifIcon: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
    fontSize: '14px',
    fontFamily: 'Averta',
    color: '#ffffff',
  },
  list: {
    width: '410px !important',
    padding: '0 !important',
    overflow: 'hidden',
    boxSizing: 'border-box',
  },
  content: {
    width: 'fit-content',
    display: 'flex',
    flexDirection: 'column',
    padding: '0 10px 0 15px',
    margin: '6px 0',
    outline: 'none',
    overflowy: 'auto',
    maxHeight: '80vh',
    '@media (max-width: 1500px)': {
      maxHeight: '76vh',
    },
    // border: '1px solid #FFAD00',
    borderRadius: '4px',
  },
  loadingLazy: {
    position: 'absolute',
    bottom: '0',
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#ffffff',
    marginLeft: '-15px',
    padding: '15px',
    zoom: '0.5',
  },
  notiTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '12px 0px 2px',
    borderBottom: '1px solid #E8E8E8',
    margin: '0px 28px 0px 15px',
  },
  notiSeeAllIcon: {
    cursor: 'pointer',
    '&:hover': {
      '& path': {
        stroke: '#626262 !important',
      },
    },
  },
  notiMuteIcon: {
    cursor: 'pointer',
    '&:hover': {
      '& path': {
        stroke: '#626262 !important',
      },
    },
  },
  notiTabs: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '12px 0px 0px',
    borderBottom: '1px solid #E8E8E8',
    margin: '0px 15px',
  },
  notiTitleSpan: {
    display: 'flex',
    gap: 12,
  },
  notiTitleText: {
    fontFamily: 'Averta Bold',
    fontSize: 18,
  },
  notiTitleNumber: {
    fontFamily: 'Averta Bold',
    fontSize: 18,
    color: '#FB3748',
    paddingBottom: 5,
  },
  notiTitleTabs: {
    fontFamily: 'Averta',
    fontSize: 15,
    cursor: 'pointer',
    color: '#999999',
    paddingBottom: 5,
  },
  notiTitleTabsActive: {
    fontFamily: 'Averta Bold',
    fontSize: 15,
    color: '#335CFF',
    borderBottom: '1px solid #335CFF',
    cursor: 'pointer',
  },
  loading: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '10px 0',
    zoom: '0.5',
  },
  redDot: {
    position: 'absolute',
    top: 10,
    right: 9,
    width: 9,
    height: 9,
    borderRadius: 10,
    backgroundColor: '#e4464b',
    display: ({ notif }) =>
      notif.chat || notif.order || notif.request || notif['whatsapp-messages']
        ? 'block'
        : 'none',
  },
  empty: {
    fontSize: 16,
    color: '#303030',
    fontFamily: 'Averta Light',
  },
  but: {
    fontSize: 15,
    color: '#303030',
    fontFamily: 'Averta Light',
    textAlign: 'center',
    display: 'block',
    marginBottom: 5,
  },
  notificationToast: {
    position: 'fixed',
    top: 'calc(100dvh - 128px)', // Use dynamic viewport height for mobile
    right: 10,
    zIndex: 9999999,
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    // Fallback for browsers that don't support dvh
    '@supports not (height: 100dvh)': {
      top: 'calc(100vh - 128px)',
    },
    // Additional mobile-specific positioning
    '@media (max-width: 768px)': {
      top: 'calc(100dvh - 128px)',
      '@supports not (height: 100dvh)': {
        top: 'calc(100vh - 128px)',
        // Use JavaScript-calculated height as last resort
        '&[data-viewport-height]': {
          top: 'calc(var(--viewport-height, 100vh) - 128px)',
        },
      },
    },
  },
  '&:first-child': {
    boxShadow: '0px 10px 10px 1px #0000001c',
    zIndex: '9999999 !important',
    position: 'relative',
  },
});
